import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import Ribbon from '@/core/ribbon/ribbon.vue';
import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';
import '@/shared/config/dayjs';
import SidebarComponent from './core/sidebar/sidebar.vue';
import DataUserComponent from './core/sidebar/user/data-user.vue';

@Component({
  components: {
    ribbon: Ribbon,
    'jhi-navbar': JhiNavbar,

    'jhi-footer': JhiFooter,
    sidebar: SidebarComponent,
    dataUser: DataUserComponent,
  },
  computed: {
    ...mapGetters(['authenticated']),
  },
})
export default class App extends Vue {
  public scrollPosition: number = window.scrollY;
  public authenticated;
  public isCommentDialogActivated = false;
  private lastScrollY: number = window.scrollY;
  private currentHeaderState: 'engrozar' | 'adelgazar' = 'engrozar';

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  private handleScroll() {
    const currentScrollY = window.scrollY;
    const threshold = 10;

    if (currentScrollY - this.lastScrollY > threshold) {
      if (this.currentHeaderState !== 'adelgazar') {
        this.currentHeaderState = 'adelgazar';
      }
    } else if (this.lastScrollY - currentScrollY > threshold) {
      if (this.currentHeaderState !== 'engrozar') {
        this.currentHeaderState = 'engrozar';
      }
    }

    this.scrollPosition = currentScrollY;
    this.lastScrollY = currentScrollY;
  }

  get headerClasses() {
    const baseClass = this.authenticated ? 'header-conacyt sticky-top' : 'header-conacyt-sesion';
    return [baseClass, this.currentHeaderState];
  }
}
